import React, { Component } from "react";
import { useParams } from 'react-router-dom';
import PageHelmet from "../component/common/Helmet";
import ModalVideo from 'react-modal-video';
import { FaTwitter, FaInstagram, FaFacebookF, FaLinkedinIn } from "react-icons/fa";
import ScrollToTop from 'react-scroll-up';
import { FiChevronUp } from "react-icons/fi";
import Header from "../component/header/Header";
import Footer from "../component/footer/Footer";
import { LanguageContext } from '../context/LanguageContext';
import translations from '../translations';

const SocialShare = [
    { Social: <FaFacebookF />, link: 'https://www.facebook.com/massDevelop' },
    { Social: <FaLinkedinIn />, link: 'https://www.linkedin.com/company/mass-dev/' },
    { Social: <FaInstagram />, link: 'https://www.instagram.com/mass.develop/' },
]

class FreemiumDetailsContent extends Component {
    static contextType = LanguageContext;

    constructor() {
        super()
        this.state = {
            isOpen: false
        }
        this.openModal = this.openModal.bind(this)
    }
    
    openModal() {
        this.setState({ isOpen: true })
    }

    render() {
        const { language } = this.context;
        const t = translations[language];
        const { id } = this.props;

        // Find the freemium item by ID
        const freemiumItem = t.portfolio.items.find(item => item.id === id);

        if (!freemiumItem) {
            return (
                <React.Fragment>
                    <PageHelmet pageTitle='Freemium Not Found' />
                    <Header headertransparent="header--transparent" colorblack="color--black" logoname="logo.png" />
                    <div className="rn-page-title-area pt--120 pb--190 bg_image bg_image--2" data-black-overlay="7">
                        <div className="container">
                            <div className="row">
                                <div className="col-lg-12">
                                    <div className="rn-page-title text-center pt--100">
                                        <h2 className="title theme-gradient">Freemium Not Found</h2>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <Footer />
                </React.Fragment>
            );
        }

        return (
            <React.Fragment>
                <PageHelmet pageTitle={freemiumItem.title} />
                <Header headertransparent="header--transparent" colorblack="color--black" logoname="logo.png" />

                {/* Start Breadcrump Area */}
                <div className="rn-page-title-area pt--120 pb--190 bg_image bg_image--2" data-black-overlay="7">
                    <div className="container">
                        <div className="row">
                            <div className="col-lg-12">
                                <div className="rn-page-title text-center pt--100">
                                    <h2 className="title theme-gradient">{freemiumItem.title}</h2>
                                    <p>{freemiumItem.category}</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                {/* End Breadcrump Area */}

                {/* Start Portfolio Details */}
                <div className="rn-portfolio-details ptb--120 bg_color--1">
                    <div className="container">
                        <div className="row">
                            <div className="col-lg-12">
                                <div className="portfolio-details">
                                    <div className="inner">
                                        <h2>{language === 'ar' ? 'مقدمة' : 'Introduction'}</h2>
                                        <p className="subtitle">{language === 'ar' ? 'في المشهد الرقمي المتطور بسرعة اليوم، يعد البقاء في الطليعة أمرًا ضروريًا للشركات والأفراد على حد سواء.' : 'In today\'s rapidly evolving digital landscape, staying ahead of the curve is essential for businesses and individuals alike.'}</p>
                                        <p>{language === 'ar' ? 'Mass.Dev، شركة رائدة، تُحدث ثورة في العالم العربي من خلال تقديم فعاليات مجانية ومميزة - مزيج قوي من العروض المجانية والمميزة التي تهدف إلى تمكين الجيل الجديد بحلول تجربة المستخدم وتطوير الويب الحديثة عالية التقنية. مع الالتزام بالتميز والابتكار، تمهد Mass.Dev الطريق للعصر القادم من التحول الرقمي في العالم العربي، ملهمة العقول الشابة لمطاردة الميزات الجديدة واحتضان أحدث التقنيات.' : 'Mass.Dev, a groundbreaking company, is revolutionizing the Arab world by introducing Freemiums - a powerful fusion of Free and Premium offerings that aims to empower the new generation with modern high-tech UX and web development solutions. With a commitment to excellence and innovation, Mass.Dev is setting the stage for the next era of digital transformation in the Arab world, inspiring young minds to chase new features and embrace the cutting-edge in technology.'}</p>

                                        <div className="portfolio-share-link mt--20 pb--70 pb_sm--40">
                                            <ul className="social-share rn-lg-size d-flex justify-content-start liststyle mt--15">
                                                {SocialShare.map((val, i) => (
                                                    <li key={i}><a href={`${val.link}`} target="_blank" rel="noopener noreferrer">{val.Social}</a></li>
                                                ))}
                                            </ul>
                                        </div>
                                    </div>

                                    <div className="portfolio-thumb-inner">
                                        <div className="thumb mb--30">
                                            <img src="/assets/images/portfolio/portfolio-big-03.jpg" alt="Portfolio Images" />
                                        </div>
                                        <div className="thumb">
                                            <img src="/assets/images/portfolio/portfolio-big-02.jpg" alt="Portfolio Images" />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                {/* End Portfolio Details */}

                {/* Start Back To Top */}
                <div className="backto-top">
                    <ScrollToTop showUnder={160}>
                        <FiChevronUp />
                    </ScrollToTop>
                </div>
                {/* End Back To Top */}

                <Footer />
            </React.Fragment>
        );
    }
}

// Wrapper component to use hooks
function FreemiumDetails() {
    const { id } = useParams();
    return <FreemiumDetailsContent id={id} />;
}

export default FreemiumDetails;

